import React from 'react'
import { Box, Button, Switch, FormControlLabel, FormControl } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSurveyStore } from '../../surveyutilities/surveyStore';

function BlockSettingsControl({ block }) {
    const { removeQuestion, duplicateQuestion, updateQuestion } = useSurveyStore();
    const currentState = useSurveyStore(s => s)

    const handleDelete = () => {
        console.log("current state :")
        console.log(currentState);
        removeQuestion(block.id)
    }

    const handleRequiredToggle = (event) => {
        updateQuestion(block.id, { required: event.target.checked });
    }

    return (
        <Box sx={{ 
            mt: 2, 
            display: 'flex', 
            justifyContent: 'end', 
            alignItems: 'center', 
            alignContent: 'center' 
        }}>
            <Button
                variant='text'
                sx={{ marginRight: 2 }} 
                startIcon={<ContentCopyIcon />} 
                onClick={() => duplicateQuestion(block.id)}
                size='small'
            >
                Duplicate
            </Button>
            
            <FormControl>
                <FormControlLabel 
                    size="small" 
                    control={
                        <Switch 
                            checked={block.required || false} 
                            onChange={handleRequiredToggle}
                        />
                    } 
                    label="Required*"
                />
            </FormControl>
            
            <Button 
                variant='text' 
                sx={{ marginLeft: 2 }} 
                startIcon={<DeleteIcon />} 
                onClick={handleDelete}
                size='small'
            >
                Delete
            </Button>
        </Box>
    )
}

export default BlockSettingsControl